<template>
  <div class="Page Partners">
    <h2 class="subtitle">
      Liste des entreprises -
      <router-link class="button is-small" :to="'/partner/new'"
        >Ajouter</router-link
      >
    </h2>
    <PaginatedList
      :items="s_partners"
      :loading="loading"
      :per-page.sync="perPage"
    >
      <template slot="search">
        <horiz-field>
          <label class="label" slot="label">Chercher</label>
          <input type="text" class="input" v-model="query" />
        </horiz-field>
        <help-message>
          <h3 slot="title">Liste des entreprises</h3>
          <p>
            D'ici, vous pouvez visualiser les différentes entreprises ajoutées
            lors du remplissage des projets. <br />Il vous est aussi possible de
            compléter leurs fiches ( <a> éditer <i class="fa fa-edit"></i> </a>)
            ou de manuellement en créer de nouvelles. <br />Depuis la page
            d'édition d'entreprises, vous pouvez aussi éditer les contacts en
            faisant partie.
          </p>
        </help-message>
      </template>
      <template slot="table-headers">
        <td>Logo</td>
        <td>
          Nom
          <updown
            :me="$options.sortmodes.BY_NAME"
            @dir="sort = $event"
            :sort="sort"
          />
        </td>
        <td>
          Nb. Équipiers
          <updown
            :me="$options.sortmodes.BY_EMPLOYEES"
            @dir="sort = $event"
            :sort="sort"
          />
        </td>
        <td>Actions</td>
      </template>
      <template slot="paginated-listItem" slot-scope="{ paginatedItem }">
        <td style="max-width: 32px;">
          <api-picture :picture-id="paginatedItem.logo_id"></api-picture>
        </td>
        <td>
          <router-link :to="`/partners/view/${paginatedItem.uuid}`">
            {{ paginatedItem.name }}
          </router-link>
        </td>
        <td>
          <p v-if="paginatedItem.contacts_count">
            {{ paginatedItem.contacts_count }}
          </p>
        </td>
        <td>
          <router-link
            class="is-small"
            :to="`/partner/edit/${paginatedItem.uuid}`"
          >
            éditer&nbsp; <i class="fas fa-edit"></i> </router-link
          >&nbsp;
          <a
            class="is-small has-text-danger"
            @click="deletePartner(paginatedItem)"
            >supprimer</a
          >
        </td>
      </template>
    </PaginatedList>
  </div>
</template>

<script>
import { types as t, sortmodes } from "../../store/actions/partners";
import { SCARY_MODAL } from "../../store/actions/actions";
import { deepGet, toKeys } from "../../util/func";
import HorizField from "../../components/Form/HorizField";
import Updown from "./../../components/Form/Updown";
import ApiPicture from "../../components/Form/ApiPicture";
import HelpMessage from "../../components/Form/HelpMessage";
import PaginatedList from "@/components/Layout/PaginatedList";

export default {
  name: "Partners",
  components: { HelpMessage, ApiPicture, PaginatedList, Updown, HorizField },
  data() {
    return {
      loading: false,
      query: "",
      perPage: 15,
      partners: [],
      sort: {
        mode: sortmodes.BY_ID,
        dir: 0
      }
    };
  },
  sortmodes,
  computed: {
    f_partners() {
      if (!this.query.toLowerCase().trim()) return this.partners;
      return this.partners.filter(
        p =>
          p.name.toLowerCase().indexOf(this.query.toLowerCase().trim()) !== -1
      );
    },
    s_partners() {
      const keys = toKeys(this.sort.mode);
      const co = this.sort.dir === 0 ? 1 : -1;
      return this.f_partners.slice(0).sort((b, a) => {
        return (deepGet(b, keys) <= deepGet(a, keys) ? -1 : 1) * co;
      });
    }
  },
  methods: {
    deletePartner(partner) {
      this.$root.$emit(SCARY_MODAL, {
        message: `Voulez-vous vraiment supprimer ${partner.name} ?`,
        action: async () => {
          await this.$store.dispatch(t.DELETE_PARTNER, partner.id);
          return this.fetch();
        }
      });
    },
    async fetch() {
      this.loading = true;
      this.partners = await this.$store.dispatch(t.GET_PARTNERS);
      this.loading = false;
    }
  },
  async mounted() {
    this.fetch();
  }
};
</script>
